import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Typography, Box, InputAdornment } from '@mui/material';
import axios from 'axios';
import { Backdrop, CircularProgress } from '@mui/material';

import { useAuth } from '../../../Auth/AuthContext';
import { parseColombianMoneyInput } from '../../../utils/money';

const API_URL = process.env.REACT_APP_API_URL;

function DialogFinalizarTurno({ dialogOpen, handleDialogClose, currentCaja }) {
  const { logout } = useAuth();
  const [loading, setLoading] = useState(false);

  const [montoFinal, setMontoFinal] = useState('');
  const [error, setError] = useState('');

  const handleGuardar = async () => {
    if (!montoFinal) {
      setError('Debe ingresar el monto final para finalizar el turno.');
      return;
    }
    setLoading(true);

    try {
      const canonicalAmount = parseColombianMoneyInput(montoFinal);
      // Obtener la fecha actual en la zona horaria de Bogotá
      const now = new Date().toLocaleString("en-US", { timeZone: "America/Bogota" });
      const date = new Date(now);

      // Función para agregar ceros a la izquierda
      const pad = (n) => n.toString().padStart(2, '0');

      // Formatear en %Y-%m-%d %H:%M:%S
      const formattedDate = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
      
      await axios.put(`${API_URL}/cajas/${currentCaja.id}/`, {
        movimientos: currentCaja.movimientos,
        estado: false,
        saldo_final: canonicalAmount,
        fecha_hora_fin: formattedDate,
        nombre: currentCaja.nombre
      });
      setLoading(false);
      logout()
    } catch (err) {
      setLoading(false);
      setError('Hubo un error al finalizar el turno.');
      console.error(err);
    }
  };

  const handleClose = () => {
    setMontoFinal('');
    setError('');
    handleDialogClose();
  };

  return (
    <Dialog open={dialogOpen} onClose={handleClose}>
      <Backdrop
        open={loading}
        style={{ zIndex: 9999, color: '#fff' }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <DialogTitle sx={{ fontWeight: 'bold' }}>Finalizar Turno</DialogTitle>
      <DialogContent>
        {currentCaja && (
          <Box sx={{ marginBottom: 2 }}>
            <Typography><strong>Total Sin Base:</strong> {Number(currentCaja.total_ingresos) - Number(currentCaja.total_egresos)}</Typography>
            <Typography><strong>Total Con Base:</strong> {(Number(currentCaja.total_ingresos) - Number(currentCaja.total_egresos)) + Number(currentCaja.dinero_base)}</Typography>
            <Typography><strong>Total Ingresos:</strong> {currentCaja.total_ingresos}</Typography>
            <Typography><strong>Total Egresos:</strong> {currentCaja.total_egresos}</Typography>
          </Box>
        )}
        <Typography>
          Ingrese el monto total en efectivo para verificar discrepancias.
        </Typography>
        <TextField
          label="Monto Final En Efectivo"
          type="text"
          inputMode="decimal"
          fullWidth
          value={montoFinal}
          onChange={(e) => setMontoFinal(e.target.value)}
          InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment>, maxLength: 10 }} 
          error={!!error}
          helperText={error}
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          Cancelar
        </Button>
        <Button variant="contained" color="primary" onClick={handleGuardar}>
          Finalizar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogFinalizarTurno;
